import { render, staticRenderFns } from "./tel_visits.vue?vue&type=template&id=2af24c7a&scoped=true&"
import script from "./tel_visits.vue?vue&type=script&lang=js&"
export * from "./tel_visits.vue?vue&type=script&lang=js&"
import style0 from "./tel_visits.vue?vue&type=style&index=0&id=2af24c7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af24c7a",
  null
  
)

export default component.exports